export default "__VITE_ASSET__$aJaEy6w__";